var ur = window.location.href;
if(ur.includes('/product')){
  jQuery(document).ready(function(){
    
    
var ur = window.location.href;
if(ur.includes('/product')){
jQuery(document).ready(function(){
   setInterval(function(){ 
 if(jQuery('.cc-window.cc-banner.cc-type-info.cc-invisible').length) {
	jQuery('body').addClass('no-cookie-consent')
 }
     else{
       	jQuery('body').removeClass('no-cookie-consent')
     }
}, 1000);
    
  var btnClass = "button#Addtocart";
  var imgsrc = jQuery('.slick-slide img').eq(0).attr('src');;
    
  Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="simple-st-container" id="simple-st-containerID"> <div class="simple-st-container__outer"><div class="simple-product-cont"><img class="sticky-image" src="'+imgsrc+'"><div class="simple-product-name"><p></p></div><div class="simple-product-price"></div></div> <div class="simple-st-container__inner"> <div class="st-price-container"><span class="st-price-label">PRICE</span><span class="st-price"></span></div><div class="simple-select-container"> <div class="simple-st-select" id="st-select0"> <span>Color</span> <select> <option></option> </select> </div><div class="simple-st-select" id="st-select1"> <span>Type</span> <select> <option></option> </select> </div><div class="simple-st-select" id="st-select2"> <span>Type</span> <select> <option></option> </select> </div></div><div class="simple-st-item_column__button"><a class="simple-st-item__button" rel="nofollow">Add to Cart</a></div></div></div></div>';
var y = document.getElementsByTagName('body');
if(document.getElementsByClassName('simple-st-container').length == 0){
  y[0].appendChild(sticky);
  var mmg = 0; var timermmg = setInterval(function(){
  if( jQuery('.ground-product-gallery img').eq(0).attr('src').length > 10 ) {
jQuery('.sticky-image').eq(0).attr('src', jQuery('.ground-product-gallery div > img').eq(0).attr('src'))
clearInterval(timermmg);}if( mmg > 200){clearInterval(timermmg);}mmg++;}, 50);
  
jQuery('.simple-product-name p').eq(0).html(jQuery('h1.ProductMeta__Title.Heading.u-h2').eq(0).text());
   setTimeout(function(){ 
  jQuery('.simple-product-name').append(jQuery('.loox-rating').eq(0).clone());
       var ll = 0; var timerll = setInterval(function(){
  if($('.loox-rating').length) {
	$('.loox-rating').click(function(){
  window.scrollTo({
    top: document.querySelectorAll('iframe#looxReviewsFrame')[0].offsetTop - 50,
    behavior: 'smooth'
});
}); 
clearInterval(timerll);}if( ll > 200){clearInterval(timerll);}ll++;}, 50);
}, 1000);
  jQuery('.st-price').eq(0).html(jQuery('span.ProductMeta__Price.Price').eq(0).text());
  
 
function populateOptions(select, labels){
  var selected = 0;
  labels = labels.eq(0).find('li label');
  for(var i =0; i < labels.length; i++){
      var option = document.createElement('OPTION');
    
      var t = document.createTextNode(labels.eq(i).html());
      option.appendChild(t);
   	  option.id = i;
      select.appendChild(option);
    
    	if(i == 0){
          select.removeChild(select.firstElementChild);
          
          
        }
    
    if(labels.eq(i).prev().attr('checked')){
          selected = i;
          
          
        }
    
  }
  
  select.selectedIndex = selected;
}
  
  jQuery('.simple-st-item__button').click(function(){
   if(!jQuery('.simple-st-item__button').hasClass("simple-st-disabled")){
     
document.querySelectorAll('.ProductForm__BuyButtons button#Addtocart')[0].click()
      }
    
   
  });
  
    
    
};
  
     function checkIfDisabled() {
         setTimeout(function () {
             var elem = jQuery(btnClass ).eq(0);
             jQuery('.simple-st-item__button').html(elem.text());
             if (elem.text().toUpperCase() != 'ADD TO CART') {
                 jQuery('.simple-st-item__button').html(elem.text());
                 jQuery('.simple-st-item__button').addClass('simple-st-disabled');
             } else {
                 jQuery('.simple-st-item__button').removeClass('simple-st-disabled');
             }
         }, 100);
     }
//checkIfDisabled();
 
    
  checkIfDisabled();
  
function isVisible(elem){
var elementTop = elem.offset().top;
var elementBottom = elementTop + elem.outerHeight();
var viewportTop = jQuery(window).scrollTop();
var viewportBottom = viewportTop + jQuery(window).height();
return elementBottom > viewportTop && elementTop < viewportBottom;
};
       
var mc = window.matchMedia("(min-width: 767px)");
        
        
    var elem = document.getElementById("simple-st-containerID");      
    function slideShow() {
          jQuery('body').addClass('simple-sticky');
    }
          		
     function slideHide() {    
        jQuery('body').removeClass('simple-sticky');
     }
              
    jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > jQuery('button#Addtocart').eq(0).offset().top) {
       slideShow();
            
    } else {
  
        slideHide();
        
    }
});   
});                             
}
    
  var ll = 0; var timerll = setInterval(function(){
  if($('.loox-rating').length) {
	$('.loox-rating').click(function(){
  window.scrollTo({
    top: document.querySelectorAll('iframe#looxReviewsFrame')[0].offsetTop - 50,
    behavior: 'smooth'
});
}); 
clearInterval(timerll);}if( ll > 200){clearInterval(timerll);}ll++;}, 50);
    });
}
jQuery.getScript( "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js" , function ( data, textStatus, jqxhr ) {
var sss = 0; var timersss = setInterval(function(){
  if(jQuery('.slick-initialized').length == 0) {
	  $('.slider-for').slick({
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        arrows: true,
                                        dots: false,
                                        fade: true,
                                        adaptiveHeight: true,
                                        prevArrow: "<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/2561/8502/files/arrow-icon.svg?v=1654154851'></button>",
                                        nextArrow: "<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/2561/8502/files/arrow-icon.svg?v=1654154851'></button>",
                                        asNavFor: '.slider-nav'
                                    });
                                    $('.slider-nav').slick({
                                        slidesToShow: 4.5,
                                        slidesToScroll: 1,
                                        asNavFor: '.slider-for',
                                        dots: false,
                                        arrows: false,
                                        focusOnSelect: true
                                    });
}else{
 clearInterval(timersss); 
}
  if( sss > 200){clearInterval(timersss);}sss++;}, 50);
                                  
});




/* USP Badges */
var ur = window.location.href;
if(ur.includes('/product')){
  $(document).ready(function(){
    Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var imgSrcs = ['https://cdn.shopify.com/s/files/1/2561/8502/files/world.png?v=1688453222',
'https://cdn.shopify.com/s/files/1/2561/8502/files/tracker.png?v=1688453223',  
'https://cdn.shopify.com/s/files/1/2561/8502/files/return.png?v=1688453222',
'https://cdn.shopify.com/s/files/1/2561/8502/files/secure.png?v=1688453222'
];
var badgeTexts = ["Ships Anywhere in the World",
                  "All Shipped Orders are Tracked",
                  "28-Day Return Policy",
                "Secure Checkout"];
var container = document.createElement('div');
container.className = 'simple-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'simple-img-container';
var y = document.querySelectorAll('.ProductForm__BuyButtons')[0];
if(document.getElementsByClassName('simple-img-container').length == 0){
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  
}
    
for(var i = 0; i < imgSrcs.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="simple-badge-container"><img src="' + imgSrcs[i] +  '"><span class="badge'+i+'">'+badgeTexts[i]+'</span></div>';
    imgContainer.appendChild(img);
    img.className = "simple-badges-container";
           
    
}   
    if($('.ProductMeta + .simple-badges-outer-container').length == 0){
      $('.ProductMeta').eq(0).after($('.simple-badges-outer-container').eq(0).clone());
    }
    
  
  
  
  });
}

/* USP Badges End*/



/* Homepage redesign */
jQuery(document).ready(function(){
console.log('start homepage')
    
jQuery('.ButtonGroup.ButtonGroup--spacingSmall').append('<img src="https://cdn.shopify.com/s/files/1/2561/8502/files/trustpilot.png?v=1699972703">')
console.log('append homepage')
jQuery('div#shopify-section-template--14987228512361__slideshow').after('<div class="shadow-container"></div><div class="badges-container"> <div class="badges-column-container"> <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55" fill="none"> <mask id="mask0_13_10" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="55" height="55"> <rect width="55" height="55" fill="#D9D9D9"></rect> </mask> <g mask="url(#mask0_13_10)"> <path d="M27.5 50.4166C24.3298 50.4166 21.3507 49.8151 18.5625 48.612C15.7743 47.4088 13.3489 45.776 11.2864 43.7135C9.22394 41.651 7.59113 39.2257 6.388 36.4375C5.18488 33.6493 4.58331 30.6701 4.58331 27.5C4.58331 24.3298 5.18488 21.3507 6.388 18.5625C7.59113 15.7743 9.22394 13.3489 11.2864 11.2864C13.3489 9.22394 15.7743 7.59113 18.5625 6.388C21.3507 5.18488 24.3298 4.58331 27.5 4.58331C30.6701 4.58331 33.6493 5.18488 36.4375 6.388C39.2257 7.59113 41.651 9.22394 43.7135 11.2864C45.776 13.3489 47.4088 15.7743 48.612 18.5625C49.8151 21.3507 50.4166 24.3298 50.4166 27.5C50.4166 30.6701 49.8151 33.6493 48.612 36.4375C47.4088 39.2257 45.776 41.651 43.7135 43.7135C41.651 45.776 39.2257 47.4088 36.4375 48.612C33.6493 49.8151 30.6701 50.4166 27.5 50.4166ZM25.2083 45.7187V41.25C23.9479 41.25 22.8689 40.8012 21.9713 39.9036C21.0738 39.0061 20.625 37.9271 20.625 36.6666V34.375L9.62498 23.375C9.5104 24.0625 9.40536 24.75 9.30988 25.4375C9.21439 26.125 9.16665 26.8125 9.16665 27.5C9.16665 32.1215 10.6849 36.1701 13.7213 39.6458C16.7578 43.1215 20.5868 45.1458 25.2083 45.7187ZM41.0208 39.875C41.7847 39.0347 42.4722 38.1276 43.0833 37.1536C43.6944 36.1797 44.2005 35.1675 44.6015 34.1172C45.0026 33.0668 45.3081 31.9878 45.5182 30.8802C45.7283 29.7725 45.8333 28.6458 45.8333 27.5C45.8333 23.7569 44.7925 20.3385 42.7109 17.2448C40.6293 14.151 37.8507 11.9166 34.375 10.5416V11.4583C34.375 12.7187 33.9262 13.7977 33.0286 14.6953C32.1311 15.5929 31.0521 16.0416 29.7916 16.0416H25.2083V20.625C25.2083 21.2743 24.9887 21.8186 24.5495 22.2578C24.1102 22.697 23.566 22.9166 22.9166 22.9166H18.3333V27.5H32.0833C32.7326 27.5 33.2769 27.7196 33.7161 28.1588C34.1554 28.5981 34.375 29.1423 34.375 29.7916V36.6666H36.6666C37.6597 36.6666 38.5573 36.9627 39.3594 37.5547C40.1614 38.1467 40.7153 38.9201 41.0208 39.875Z" fill="#D777AD"></path> </g> </svg> <div class="badges-copy">Ships Anywhere in the World</div></div><div class="badges-column-container"> <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55" fill="none"> <mask id="mask0_13_15" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="55" height="55"> <rect width="55" height="55" fill="#D9D9D9"></rect> </mask> <g mask="url(#mask0_13_15)"> <path d="M27.4993 27.5C28.7598 27.5 29.8388 27.0512 30.7363 26.1536C31.6339 25.2561 32.0827 24.1771 32.0827 22.9166C32.0827 21.6562 31.6339 20.5772 30.7363 19.6797C29.8388 18.7821 28.7598 18.3333 27.4993 18.3333C26.2389 18.3333 25.1599 18.7821 24.2624 19.6797C23.3648 20.5772 22.916 21.6562 22.916 22.9166C22.916 24.1771 23.3648 25.2561 24.2624 26.1536C25.1599 27.0512 26.2389 27.5 27.4993 27.5ZM27.4993 44.3437C32.1591 40.0659 35.6157 36.1797 37.8691 32.6849C40.1226 29.1901 41.2494 26.0868 41.2494 23.375C41.2494 19.2118 39.9221 15.8029 37.2676 13.1484C34.6131 10.4939 31.357 9.16665 27.4993 9.16665C23.6417 9.16665 20.3856 10.4939 17.7311 13.1484C15.0766 15.8029 13.7493 19.2118 13.7493 23.375C13.7493 26.0868 14.8761 29.1901 17.1296 32.6849C19.383 36.1797 22.8396 40.0659 27.4993 44.3437ZM27.4993 50.4166C21.35 45.184 16.7572 40.3238 13.7207 35.8359C10.6842 31.3481 9.16602 27.1944 9.16602 23.375C9.16602 17.6458 11.0089 13.0816 14.6947 9.68227C18.3804 6.28297 22.6487 4.58331 27.4993 4.58331C32.35 4.58331 36.6183 6.28297 40.304 9.68227C43.9898 13.0816 45.8327 17.6458 45.8327 23.375C45.8327 27.1944 44.3145 31.3481 41.278 35.8359C38.2415 40.3238 33.6487 45.184 27.4993 50.4166Z" fill="#D777AD"></path> </g></svg> <div class="badges-copy">All Shipped Orders are Tracked</div></div><div class="badges-column-container"> <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55" fill="none"> <mask id="mask0_13_20" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="55" height="55"> <rect width="55" height="55" fill="#D9D9D9"></rect> </mask> <g mask="url(#mask0_13_20)"> <path d="M11.4583 50.4166C10.1979 50.4166 9.11892 49.9679 8.22135 49.0703C7.32378 48.1727 6.875 47.0937 6.875 45.8333V13.75C6.875 12.4896 7.32378 11.4106 8.22135 10.513C9.11892 9.61543 10.1979 9.16665 11.4583 9.16665H13.75V4.58331H18.3333V9.16665H36.6667V4.58331H41.25V9.16665H43.5417C44.8021 9.16665 45.8811 9.61543 46.7786 10.513C47.6762 11.4106 48.125 12.4896 48.125 13.75V27.5H43.5417V22.9166H11.4583V45.8333H27.5V50.4166H11.4583ZM43.5417 55C40.7535 55 38.3186 54.1311 36.237 52.3932C34.1554 50.6554 32.8472 48.4687 32.3125 45.8333H35.8646C36.3611 47.5139 37.3064 48.8889 38.7005 49.9583C40.0946 51.0278 41.7083 51.5625 43.5417 51.5625C45.7569 51.5625 47.6476 50.7795 49.2135 49.2135C50.7795 47.6476 51.5625 45.7569 51.5625 43.5416C51.5625 41.3264 50.7795 39.4357 49.2135 37.8698C47.6476 36.3038 45.7569 35.5208 43.5417 35.5208C42.434 35.5208 41.4028 35.7213 40.4479 36.1224C39.4931 36.5234 38.6528 37.0868 37.9271 37.8125H41.25V41.25H32.0833V32.0833H35.5208V35.3489C36.5521 34.3559 37.7552 33.5633 39.1302 32.9713C40.5052 32.3793 41.9757 32.0833 43.5417 32.0833C46.7118 32.0833 49.4141 33.2005 51.6484 35.4349C53.8828 37.6693 55 40.3715 55 43.5416C55 46.7118 53.8828 49.414 51.6484 51.6484C49.4141 53.8828 46.7118 55 43.5417 55ZM11.4583 18.3333H43.5417V13.75H11.4583V18.3333Z" fill="#D777AD"></path> </g></svg> <div class="badges-copy">28-Day Return Policy</div></div><div class="badges-column-container"> <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55" fill="none"> <mask id="mask0_13_25" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="55" height="55"> <rect width="55" height="55" fill="#D9D9D9"></rect> </mask> <g mask="url(#mask0_13_25)"> <path d="M27.4974 50.4166C22.1884 49.0798 17.8056 46.0338 14.349 41.2786C10.8924 36.5234 9.16406 31.243 9.16406 25.4375V11.4583L27.4974 4.58331L45.8307 11.4583V25.4375C45.8307 31.243 44.1024 36.5234 40.6458 41.2786C37.1892 46.0338 32.8064 49.0798 27.4974 50.4166ZM27.4974 45.6041C31.2023 44.4583 34.296 42.1953 36.7786 38.8151C39.2613 35.4349 40.7127 31.6632 41.1328 27.5H27.4974V9.4531L13.7474 14.6094V26.4687C13.7474 26.7361 13.7856 27.0798 13.862 27.5H27.4974V45.6041Z" fill="#D777AD"></path> </g></svg> <div class="badges-copy">Secure Checkout</div></div></div>')
  console.log('after homepage')
  });


/* END Homepage redesign */